import React from "react";
import { useSelector, useDispatch } from "react-redux";
// import { ordered, restocked } from "./settingsSlice";
import { set } from "./settingSlice";

import DialogContentText from "@mui/material/DialogContentText";

export const SettingsView = () => {
  // const [settingsWalletAbbr, setSettingsWalletAbbr] = useState(true);

  const walletAbbr = useSelector((state) => state.settings.walletAbbr);
  const dispatch = useDispatch();
  return (
    // <div>
    //   <h2>Number of cakes - {numOfCakes}</h2>
    //   <button onClick={() => dispatch(ordered())}>
    //     Order 1 cake (give 1 ice cream as a gift)
    //   </button>
    //   <button onClick={() => dispatch(restocked(5))}>Restock 5 cakes</button>
    // </div>
    <>
      <div>
        <input
          type="checkbox"
          name="cbWalletAbbr"
          checked={walletAbbr}
          onChange={(e) => {
            // see: <SettingsDlg />
            // cbChange(e);
            // props.setSettingsWalletAbbr(e.target.checked);
            dispatch(set(e.target.checked));
          }}
        />{" "}
        Wallet abbreviation
      </div>
      <DialogContentText className="emailP">
        The wallet abbreviation only shows a few letters at the beginning and
        end. This is used for a more compact display and to hide the wallet
        address if you are taking screenshots or making YouTube videos.
      </DialogContentText>
    </>
  );
};
